// Definición de defaults

export const defaultTipoAnexo: TipoAnexoProps = {
    idTipoAnexo:    0,
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface TipoAnexoProps {
    idTipoAnexo:    number;
    descripcion:    string;
    activo:         boolean;
}